import { render, staticRenderFns } from "./test6.vue?vue&type=template&id=52cb9055&scoped=true"
import script from "./test6.vue?vue&type=script&lang=js"
export * from "./test6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb9055",
  null
  
)

export default component.exports